import type { StepType } from "@reactour/tour";
import TourStepContent from "./wrapper";
import { text } from "@quickpoint.me/shared";

const readerFeatures: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => <strong>{text.tourSteps.a11yImageHeading}</strong>}
			/>
		),
		position: "center",
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11yAltTextHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11yAltTextPrefix} <strong>{text.tourSteps.a11yAltTextRequired}</strong>{text.tourSteps.a11yAltTextSuffix}
						<br />
						<br />
						{text.tourSteps.a11yAltTextWhy}
					</span>
				)}
			/>
		),
		position: "left",
	},
];

export default readerFeatures;
